import React from 'react';
import styled from 'styled-components';
import { Button as ButtonBase, ButtonProps } from '@mui/material';
import buttonStyles from './styles';
import { ButtonColor, ButtonSize } from './types';

export type { ButtonSize, ButtonColor };

export type Props = Omit<ButtonProps, 'size'> & {
  variant?: 'contained' | 'outlined' | 'text';
  color?: ButtonColor;
  size?: ButtonSize;
};

const StyledButton = styled(ButtonBase)<ButtonProps & { $size?: ButtonSize }>`
  ${buttonStyles}
`;

const Button = React.forwardRef<HTMLButtonElement, Props>(
  ({ size, ...rest }, ref) => {
    const muiSize =
      size === 'extraSmall' ? 'small' : (size as ButtonProps['size']);
    return <StyledButton ref={ref} size={muiSize} $size={size} {...rest} />;
  },
);

Button.displayName = 'Button';

Button.defaultProps = {
  variant: 'contained',
  color: 'primary',
};

export default Button;
